import { UserModel } from './user.type'

export const USERS_LIST: UserModel[] = [
  {
    slug: 'samir-lamir-2D8DC79KD1',
    name: 'Samir Lamir',
    avatar: 'https://i.pravatar.cc/150?img=1',
    description: `Hi I'm Samir Lamir, It will be as simple as Occidental; in fact, it will be Occidental. To an English person, it will seem like simplified English, as a skeptical Cambridge friend of mine told me what Occidental is European languages are members of the same family.
        You always want to make sure that your fonts work well together and try to limit the number of fonts you use to three or less. Experiment and play around with the fonts that you already have in the software you’re working with reputable font websites. This may be the most commonly encountered tip I received from the designers I spoke with. They highly encourage that you use different fonts in one design, but do not over-exaggerate and go overboard.`,
    role: 'Super Admin',
    followers: 21233,
    following: 1500,
    address: 'Morocco Marrakesh From Here to there Street 1520 nice nighborhood',
    skills: ['React-js', 'Remix', 'Next-js', 'CSS', 'HTML', 'JAVASCRIPT'],
    Suggestions: [],
    project: [],
    contact: {
      website: 'https://picsum.photos',
      instagram: '@hello',
      facebook: '@nice',
    },
    phone: '+(1) 9936022',
    email: 'samir_lamir@gmail.com',
  },

  {
    slug: 'sebastian-remix-1HJ5J7',
    name: 'Sebastian Remix',
    avatar: 'https://i.pravatar.cc/150?img=2',
    description: `Hi I'm Sebastian Remix, It will be as simple as Occidental; in fact, it will be Occidental. To an English person, it will seem like simplified English, as a skeptical Cambridge friend of mine told me what Occidental is European languages are members of the same family.
        You always want to make sure that your fonts work well together and try to limit the number of fonts you use to three or less. Experiment and play around with the fonts that you already have in the software you’re working with reputable font websites. This may be the most commonly encountered tip I received from the designers I spoke with. They highly encourage that you use different fonts in one design, but do not over-exaggerate and go overboard.`,
    role: 'Super Admin',
    followers: 21233,
    following: 1500,
    address: 'Morocco Marrakesh From Here to there Street 1520 nice nighborhood',
    skills: ['React-js', 'Remix', 'Next-js', 'CSS', 'HTML', 'JAVASCRIPT'],
    Suggestions: [],
    project: [],
    contact: {
      website: 'https://picsum.photos',
      instagram: '@Nice',
      facebook: '@Tomeeet',
    },
    phone: '+(1) 9936022',
    email: 'Lamia-Hello@gmail.com',
  },
  {
    slug: 'kent-c-dodds-12skj4df34',
    name: 'Kent C dodds',
    avatar: 'https://i.pravatar.cc/150?img=3',
    description: `Hi I'm Kent C dodds, It will be as simple as Occidental; in fact, it will be Occidental. To an English person, it will seem like simplified English, as a skeptical Cambridge friend of mine told me what Occidental is European languages are members of the same family.
        You always want to make sure that your fonts work well together and try to limit the number of fonts you use to three or less. Experiment and play around with the fonts that you already have in the software you’re working with reputable font websites. This may be the most commonly encountered tip I received from the designers I spoke with. They highly encourage that you use different fonts in one design, but do not over-exaggerate and go overboard.`,
    role: 'Super Admin',
    followers: 21233,
    following: 1500,
    address: 'Morocco Marrakesh From Here to there Street 1520 nice nighborhood',
    skills: ['React-js', 'Remix', 'Next-js', 'CSS', 'HTML', 'JAVASCRIPT'],
    Suggestions: [],
    project: [],
    contact: {
      website: 'https://picsum.photos',
      instagram: '@Nice',
      facebook: '@Tomeeet',
    },
    phone: '+(1) 9936022',
    email: 'Kent.C.dodds@gmail.com',
  },
  {
    slug: 'dan-san-man-12kls56',
    name: 'Dan San Man',
    avatar: 'https://i.pravatar.cc/150?img=4',
    description: `Hi I'm Dan San Man, It will be as simple as Occidental; in fact, it will be Occidental. To an English person, it will seem like simplified English, as a skeptical Cambridge friend of mine told me what Occidental is European languages are members of the same family.
        You always want to make sure that your fonts work well together and try to limit the number of fonts you use to three or less. Experiment and play around with the fonts that you already have in the software you’re working with reputable font websites. This may be the most commonly encountered tip I received from the designers I spoke with. They highly encourage that you use different fonts in one design, but do not over-exaggerate and go overboard.`,
    role: 'Super Admin',
    followers: 21233,
    following: 1500,
    address: 'Morocco Marrakesh From Here to there Street 1520 nice nighborhood',
    skills: ['React-js', 'Remix', 'Next-js', 'CSS', 'HTML', 'JAVASCRIPT'],
    Suggestions: [],
    project: [],
    contact: {
      website: 'https://picsum.photos',
      instagram: '@Nice',
      facebook: '@Tomeeet',
    },
    phone: '+(1) 9936022',
    email: 'DanSanMan@gmail.com',
  },
  {
    slug: 'ryan-forty-12nbv87',
    name: 'Ryan Forty',
    avatar: 'https://i.pravatar.cc/150?img=5',
    description: `Hi I'm Ryan Forty, lorem Saver laver kever hand over lite never find about what you want to do here in this moment form know until tomorrow in fact, it will be Occidental. To an English person, it will seem like simplified English, as a skeptical Cambridge friend of mine told me what Occidental is European languages are members of the same family.
        You always want to make sure that your fonts work well together and try to limit the number of fonts you use to three or less. Experiment and play around with the fonts that you already have in the software you’re working with reputable font websites. This may be the most commonly encountered tip I received from the designers I spoke with. They highly encourage that you use different fonts in one design, but do not over-exaggerate and go overboard.`,
    role: 'Super Admin',
    followers: 21233,
    following: 1500,
    address: 'Morocco Marrakesh From Here to there Street 1520 nice nighborhood',
    skills: ['React-js', 'Remix', 'Next-js', 'CSS', 'HTML', 'JAVASCRIPT'],
    Suggestions: [],
    project: [],
    contact: {
      website: 'https://picsum.photos',
      instagram: '@Nice',
      facebook: '@Tomeeet',
    },
    phone: '+(1) 9936022',
    email: 'ryan-florence@gmail.com',
  },
  {
    slug: 'user-6',
    name: 'Micheal Jackson',
    avatar: 'https://i.pravatar.cc/150?img=6',
    description: `Hi I'm Micheal Jackson, It will be as simple as Occidental; in fact, it will be Occidental. To an English person, it will seem like simplified English, as a skeptical Cambridge friend of mine told me what Occidental is European languages are members of the same family.
        You always want to make sure that your fonts work well together and try to limit the number of fonts you use to three or less. Experiment and play around with the fonts that you already have in the software you’re working with reputable font websites. This may be the most commonly encountered tip I received from the designers I spoke with. They highly encourage that you use different fonts in one design, but do not over-exaggerate and go overboard.`,
    role: 'Super Admin',
    followers: 21233,
    following: 1500,
    address: 'Morocco Marrakesh From Here to there Street 1520 nice nighborhood',
    skills: ['React-js', 'Remix', 'Next-js', 'CSS', 'HTML', 'JAVASCRIPT'],
    Suggestions: [],
    project: [],
    contact: {
      website: 'https://picsum.photos',
      instagram: '@Nice',
      facebook: '@Tomeeet',
    },
    phone: '+(1) 9936022',
    email: 'michealjackson@gmail.com',
  },
  {
    slug: 'user-7',
    name: 'Sara Soueidan',
    avatar: 'https://i.pravatar.cc/150?img=7',
    description: `Hi I'm Sara Soueidan, It will be as simple as Occidental; in fact, it will be Occidental. To an English person, it will seem like simplified English, as a skeptical Cambridge friend of mine told me what Occidental is European languages are members of the same family.
        You always want to make sure that your fonts work well together and try to limit the number of fonts you use to three or less. Experiment and play around with the fonts that you already have in the software you’re working with reputable font websites. This may be the most commonly encountered tip I received from the designers I spoke with. They highly encourage that you use different fonts in one design, but do not over-exaggerate and go overboard.`,
    role: 'Super Admin',
    followers: 21233,
    following: 1500,
    address: 'Morocco Marrakesh From Here to there Street 1520 nice nighborhood',
    skills: ['React-js', 'Remix', 'Next-js', 'CSS', 'HTML', 'JAVASCRIPT'],
    Suggestions: [],
    project: [],
    contact: {
      website: 'https://picsum.photos',
      instagram: '@Nice',
      facebook: '@Tomeeet',
    },
    phone: '+(1) 9936022',
    email: 'sara soueidan@gmail.com',
  },
  {
    slug: 'user-8',
    name: 'Latifa man',
    avatar: 'https://i.pravatar.cc/150?img=8',
    description: `Hi I'm Latifa man, It will be as simple as Occidental; in fact, it will be Occidental. To an English person, it will seem like simplified English, as a skeptical Cambridge friend of mine told me what Occidental is European languages are members of the same family.
        You always want to make sure that your fonts work well together and try to limit the number of fonts you use to three or less. Experiment and play around with the fonts that you already have in the software you’re working with reputable font websites. This may be the most commonly encountered tip I received from the designers I spoke with. They highly encourage that you use different fonts in one design, but do not over-exaggerate and go overboard.`,
    role: 'Super Admin',
    followers: 21233,
    following: 1500,
    address: 'Morocco Marrakesh From Here to there Street 1520 nice nighborhood',
    skills: ['React-js', 'Remix', 'Next-js', 'CSS', 'HTML', 'JAVASCRIPT'],
    Suggestions: [],
    project: [],
    contact: {
      website: 'https://picsum.photos',
      instagram: '@Nice',
      facebook: '@Tomeeet',
    },
    phone: '+(1) 9936022',
    email: 'Latifa-man@gmail.com',
  },
  {
    slug: 'user-9',
    name: 'Samia Foulik',
    avatar: 'https://i.pravatar.cc/150?img=9',
    description: `Hi I'm Samia Foulik, It will be as simple as Occidental; in fact, it will be Occidental. To an English person, it will seem like simplified English, as a skeptical Cambridge friend of mine told me what Occidental is European languages are members of the same family.
        You always want to make sure that your fonts work well together and try to limit the number of fonts you use to three or less. Experiment and play around with the fonts that you already have in the software you’re working with reputable font websites. This may be the most commonly encountered tip I received from the designers I spoke with. They highly encourage that you use different fonts in one design, but do not over-exaggerate and go overboard.`,
    role: 'Super Admin',
    followers: 21233,
    following: 1500,
    address: 'Morocco Marrakesh From Here to there Street 1520 nice nighborhood',
    skills: ['React-js', 'Remix', 'Next-js', 'CSS', 'HTML', 'JAVASCRIPT'],
    Suggestions: [],
    project: [],
    contact: {
      website: 'https://picsum.photos',
      instagram: '@Nice',
      facebook: '@Tomeeet',
    },
    phone: '+(1) 9936022',
    email: 'samia-foulik@gmail.com',
  },
  {
    slug: 'user-10',
    name: 'Sara Drasner',
    avatar: 'https://i.pravatar.cc/150?img=10',
    description: `Hi I'm Sara Drasner, It will be as simple as Occidental; in fact, it will be Occidental. To an English person, it will seem like simplified English, as a skeptical Cambridge friend of mine told me what Occidental is European languages are members of the same family.
        You always want to make sure that your fonts work well together and try to limit the number of fonts you use to three or less. Experiment and play around with the fonts that you already have in the software you’re working with reputable font websites. This may be the most commonly encountered tip I received from the designers I spoke with. They highly encourage that you use different fonts in one design, but do not over-exaggerate and go overboard.`,
    role: 'Super Admin',
    followers: 21233,
    following: 1500,
    address: 'Morocco Marrakesh From Here to there Street 1520 nice nighborhood',
    skills: ['React-js', 'Remix', 'Next-js', 'CSS', 'HTML', 'JAVASCRIPT'],
    Suggestions: [],
    project: [],
    contact: {
      website: 'https://picsum.photos',
      instagram: '@Nice',
      facebook: '@Tomeeet',
    },
    phone: '+(1) 9936022',
    email: 'SaraDrasner@gmail.com',
  },
  {
    slug: 'user-11',
    name: 'Surma Hello',
    avatar: 'https://i.pravatar.cc/150?img=11',
    description: `Hi I'm Surma Hello, It will be as simple as Occidental; in fact, it will be Occidental. To an English person, it will seem like simplified English, as a skeptical Cambridge friend of mine told me what Occidental is European languages are members of the same family.
        You always want to make sure that your fonts work well together and try to limit the number of fonts you use to three or less. Experiment and play around with the fonts that you already have in the software you’re working with reputable font websites. This may be the most commonly encountered tip I received from the designers I spoke with. They highly encourage that you use different fonts in one design, but do not over-exaggerate and go overboard.`,
    role: 'Super Admin',
    followers: 21233,
    following: 1500,
    address: 'Morocco Marrakesh From Here to there Street 1520 nice nighborhood',
    skills: ['React-js', 'Remix', 'Next-js', 'CSS', 'HTML', 'JAVASCRIPT'],
    Suggestions: [],
    project: [],
    contact: {
      website: 'https://picsum.photos',
      instagram: '@Nice',
      facebook: '@Tomeeet',
    },
    phone: '+(1) 9936022',
    email: 'surmaHello@gmail.com',
  },
  {
    slug: 'user-12',
    name: 'Kaoutar Lamix',
    avatar: 'https://i.pravatar.cc/150?img=12',
    description: `Hi I'm Kaoutar Lamix, It will be as simple as Occidental; in fact, it will be Occidental. To an English person, it will seem like simplified English, as a skeptical Cambridge friend of mine told me what Occidental is European languages are members of the same family.
        You always want to make sure that your fonts work well together and try to limit the number of fonts you use to three or less. Experiment and play around with the fonts that you already have in the software you’re working with reputable font websites. This may be the most commonly encountered tip I received from the designers I spoke with. They highly encourage that you use different fonts in one design, but do not over-exaggerate and go overboard.`,
    role: 'Super Admin',
    followers: 21233,
    following: 1500,
    address: 'Morocco Marrakesh From Here to there Street 1520 nice nighborhood',
    skills: ['React-js', 'Remix', 'Next-js', 'CSS', 'HTML', 'JAVASCRIPT'],
    Suggestions: [],
    project: [],
    contact: {
      website: 'https://picsum.photos',
      instagram: '@Nice',
      facebook: '@Tomeeet',
    },
    phone: '+(1) 9936022',
    email: 'Kaoutar Lamix@gmail.com',
  },
  {
    slug: 'user-13',
    name: 'Sebastian Lance',
    avatar: 'https://i.pravatar.cc/150?img=13',
    description: `Hi I'm Sebastian Lance, It will be as simple as Occidental; in fact, it will be Occidental. To an English person, it will seem like simplified English, as a skeptical Cambridge friend of mine told me what Occidental is European languages are members of the same family.
        You always want to make sure that your fonts work well together and try to limit the number of fonts you use to three or less. Experiment and play around with the fonts that you already have in the software you’re working with reputable font websites. This may be the most commonly encountered tip I received from the designers I spoke with. They highly encourage that you use different fonts in one design, but do not over-exaggerate and go overboard.`,
    role: 'Super Admin',
    followers: 21233,
    following: 1500,
    address: 'Morocco Marrakesh From Here to there Street 1520 nice nighborhood',
    skills: ['React-js', 'Remix', 'Next-js', 'CSS', 'HTML', 'JAVASCRIPT'],
    Suggestions: [],
    project: [],
    contact: {
      website: 'https://picsum.photos',
      instagram: '@Nice',
      facebook: '@Tomeeet',
    },
    phone: '+(1) 9936022',
    email: 'Sebastian Lance@gmail.com',
  },
  {
    slug: 'user-14',
    name: 'Fifi Lwifi',
    avatar: 'https://i.pravatar.cc/150?img=14',
    description: `Hi I'm Fifi Lwifi, It will be as simple as Occidental; in fact, it will be Occidental. To an English person, it will seem like simplified English, as a skeptical Cambridge friend of mine told me what Occidental is European languages are members of the same family.
        You always want to make sure that your fonts work well together and try to limit the number of fonts you use to three or less. Experiment and play around with the fonts that you already have in the software you’re working with reputable font websites. This may be the most commonly encountered tip I received from the designers I spoke with. They highly encourage that you use different fonts in one design, but do not over-exaggerate and go overboard.`,
    role: 'Super Admin',
    followers: 21233,
    following: 1500,
    address: 'Morocco Marrakesh From Here to there Street 1520 nice nighborhood',
    skills: ['React-js', 'Remix', 'Next-js', 'CSS', 'HTML', 'JAVASCRIPT'],
    Suggestions: [],
    project: [],
    contact: {
      website: 'https://picsum.photos',
      instagram: '@Nice',
      facebook: '@Tomeeet',
    },
    phone: '+(1) 9936022',
    email: 'Fifi Lwifi@gmail.com',
  },
  {
    slug: 'user-15',
    name: 'Kolina Serbou',
    avatar: 'https://i.pravatar.cc/150?img=15',
    description: `Hi I'm Kolina Serbou, It will be as simple as Occidental; in fact, it will be Occidental. To an English person, it will seem like simplified English, as a skeptical Cambridge friend of mine told me what Occidental is European languages are members of the same family.
        You always want to make sure that your fonts work well together and try to limit the number of fonts you use to three or less. Experiment and play around with the fonts that you already have in the software you’re working with reputable font websites. This may be the most commonly encountered tip I received from the designers I spoke with. They highly encourage that you use different fonts in one design, but do not over-exaggerate and go overboard.`,
    role: 'Super Admin',
    followers: 21233,
    following: 1500,
    address: 'Morocco Marrakesh From Here to there Street 1520 nice nighborhood',
    skills: ['React-js', 'Remix', 'Next-js', 'CSS', 'HTML', 'JAVASCRIPT'],
    Suggestions: [],
    project: [],
    contact: {
      website: 'https://picsum.photos',
      instagram: '@Nice',
      facebook: '@Tomeeet',
    },
    phone: '+(1) 9936022',
    email: 'Kolina Serbou@gmail.com',
  },
  {
    slug: 'user-16',
    name: 'john Louiss',
    avatar: 'https://i.pravatar.cc/150?img=16',
    description: `Hi I'm john Louiss, It will be as simple as Occidental; in fact, it will be Occidental. To an English person, it will seem like simplified English, as a skeptical Cambridge friend of mine told me what Occidental is European languages are members of the same family.
        You always want to make sure that your fonts work well together and try to limit the number of fonts you use to three or less. Experiment and play around with the fonts that you already have in the software you’re working with reputable font websites. This may be the most commonly encountered tip I received from the designers I spoke with. They highly encourage that you use different fonts in one design, but do not over-exaggerate and go overboard.`,
    role: 'Super Admin',
    followers: 21233,
    following: 1500,
    address: 'Morocco Marrakesh From Here to there Street 1520 nice nighborhood',
    skills: ['React-js', 'Remix', 'Next-js', 'CSS', 'HTML', 'JAVASCRIPT'],
    Suggestions: [],
    project: [],
    contact: {
      website: 'https://picsum.photos',
      instagram: '@Nice',
      facebook: '@Tomeeet',
    },
    phone: '+(1) 9936022',
    email: 'john Louiss@gmail.com',
  },
  {
    slug: 'user-17',
    name: '9ch0ach Asma',
    avatar: 'https://i.pravatar.cc/150?img=7',
    description: `Hi I'm 9ch0ach Asma, It will be as simple as Occidental; in fact, it will be Occidental. To an English person, it will seem like simplified English, as a skeptical Cambridge friend of mine told me what Occidental is European languages are members of the same family.
        You always want to make sure that your fonts work well together and try to limit the number of fonts you use to three or less. Experiment and play around with the fonts that you already have in the software you’re working with reputable font websites. This may be the most commonly encountered tip I received from the designers I spoke with. They highly encourage that you use different fonts in one design, but do not over-exaggerate and go overboard.`,
    role: 'Admin',
    followers: 21233,
    following: 1500,
    address: 'Morocco Marrakesh From Here to there Street 1520 nice nighborhood',
    skills: ['React-js', 'Remix', 'Next-js', 'CSS', 'HTML', 'JAVASCRIPT'],
    Suggestions: [],
    project: [],
    contact: {
      website: 'https://picsum.photos',
      instagram: '@Nice',
      facebook: '@Tomeeet',
    },
    phone: '+(1) 9936022',
    email: 'sara soueidan@gmail.com',
  },
]
